import { useRef, useEffect } from 'react';
import { EnrollmentStatuses } from '../../../product-updates/constants';
import usageTracker, { oldUsageTracker } from '../../usageTracker';
const APP_NAME = 'Product Updates Ui';
export const trackPageview = (screen, subscreen, numberOfLinks) => oldUsageTracker.track('pageView', {
  screen,
  subscreen,
  numberOfLinks
});
export const trackPageviewWithId = (screen, subscreen, itemId, title) => oldUsageTracker.track('pageViewWithId', {
  screen,
  subscreen,
  itemId,
  title
});
export const useTrackPageview = (screen, subscreen) => {
  const firstRun = useRef(true);
  useEffect(() => {
    if (!firstRun.current) {
      return;
    }
    firstRun.current = false;
    trackPageview(screen, subscreen);
  });
};
export const trackInteractionWithId = (screen, subscreen, feature, action, itemId) => oldUsageTracker.track('interactionWithId', {
  screen,
  subscreen,
  feature,
  action,
  itemId
});
export const trackUsage = (screen, subscreen, feature, action) => oldUsageTracker.track('usage', {
  screen,
  subscreen,
  feature,
  action
});
const mapStateToHumanReadable = {
  [EnrollmentStatuses.CANNOT_ENROLL]: 'Overridden, cannot enroll',
  [EnrollmentStatuses.CANNOT_ENROLL_TRIAL_PORTAL]: 'Trial portal, cannot enroll',
  [EnrollmentStatuses.ENROLLED_CANNOT_LEAVE]: 'Auto enrolled, cannot leave',
  [EnrollmentStatuses.NOT_ENROLLED]: 'Not participating',
  [EnrollmentStatuses.ORGANIZATION]: 'Joined as organization',
  [EnrollmentStatuses.PENDING_APPROVAL]: 'Request pending approval',
  [EnrollmentStatuses.PORTAL]: 'Joined as portal',
  [EnrollmentStatuses.USER]: 'Joined as user'
};
export const trackBetaEnrollmentChange = ({
  title,
  untranslatedTitle,
  gateName,
  currentState,
  desiredState
}) => {
  oldUsageTracker.track('betaEnrollmentChange', {
    betaName: untranslatedTitle || title,
    gates: gateName,
    // Note reusing gates property because we can't add anymore properties to amplitude at the moment
    currentState: mapStateToHumanReadable[currentState],
    nextState: mapStateToHumanReadable[desiredState]
  });
};
export const trackBetaRequest = ({
  title,
  untranslatedTitle,
  gateName
}) => {
  oldUsageTracker.track('betaRequest', {
    betaName: untranslatedTitle || title,
    gates: gateName // Note reusing gates property because we can't add anymore properties to amplitude at the moment
  });
};
export const trackEmailEngagement = ({
  portalId,
  userId,
  emailIdempotentId
}) => {
  oldUsageTracker.track('emailEngagement', {
    portalId,
    userId,
    emailIdempotentId
  });
};
export const trackEmailEngagementWithProductUpdateId = ({
  portalId,
  userId,
  productUpdateId,
  emailIdempotentId
}) => {
  oldUsageTracker.track('emailEngagementWithProductUpdateId', {
    portalId,
    userId,
    productUpdateId,
    emailIdempotentId
  });
};
export const trackGiveFeedbackButtonClick = ({
  screen,
  subscreen,
  origin,
  rolloutState,
  productUpdateId,
  productUpdateTitle
}) => {
  oldUsageTracker.track('giveFeedbackButtonClick', {
    screen,
    subscreen,
    origin,
    rolloutState,
    action: 'click give feedback button',
    productUpdateId,
    productUpdateTitle
  });
};
export const trackGiveFeedbackButtonSubmit = ({
  screen,
  subscreen,
  origin,
  rolloutState,
  productUpdateId,
  productUpdateTitle,
  rating,
  withFeedback,
  handRaised
}) => {
  oldUsageTracker.track('giveFeedbackButtonSubmit', {
    screen,
    subscreen,
    origin,
    rolloutState,
    action: 'submit beta feedback',
    productUpdateId,
    productUpdateTitle,
    rating,
    withFeedback,
    handRaised
  });
};
export const trackMeetScheduleLinkClick = ({
  screen,
  subscreen,
  origin,
  productUpdateId,
  action
}) => {
  usageTracker.track(APP_NAME, 'Meeting Schedule Link Click', {
    screen,
    subscreen,
    origin,
    productUpdateId,
    action
  });
};
export const trackFavoriteRolloutButtonClick = ({
  screen,
  subscreen,
  origin = 'panel',
  productUpdateId,
  action
}) => {
  usageTracker.track(APP_NAME, 'Favorite Rollout Button Click', {
    screen,
    subscreen,
    origin,
    productUpdateId,
    action
  });
};